import { ComponentType } from '@angular/cdk/portal';
import { BarGraphSourceReportParameterComponent } from '../parameters/bar-graph-source-report-parameter.component';
import { BooleanReportParameterComponent } from '../parameters/boolean-report-parameter.component';
import { AutoAttendantExtensionsReportParameterComponent } from '../parameters/data-to-include/auto-attendant-extensions-report-parameter.component';
import { CallDirectionsReportParameterComponent } from '../parameters/data-to-include/call-directions-report-parameter.component';
import { CallDispositionsReportParameterComponent } from '../parameters/data-to-include/call-dispositions-report-parameter.component';
import { CallQueueExtensionsReportParameterComponent } from '../parameters/data-to-include/call-queue-extensions-report-parameter.component';
import { ColumnSortReportParameterComponent } from '../parameters/data-to-include/column-sort-report-parameter.component';
import { ExtensionGroupsReportParameterComponent } from '../parameters/data-to-include/extension-groups-report-parameter.component';
import { ExtensionSortByReportParameterComponent } from '../parameters/data-to-include/extension-sort-by-report-parameter.component';
import { ExtensionsReportParameterComponent } from '../parameters/data-to-include/extensions-report-parameter.component';
import { HuntGroupExtensionsReportParameterComponent } from '../parameters/data-to-include/hunt-group-extensions-report-parameter.component';
import { PhoneNumbersReportParameterComponent } from '../parameters/data-to-include/phone-numbers-report-parameter.component';
import { SortByReportParameterComponent } from '../parameters/data-to-include/sort-by-report-parameter.component';
import { TimeRangeReportParameterComponent } from '../parameters/data-to-include/time-range-report-parameter.component';
import { DateRangeReportParameterComponent } from '../parameters/date-range-report-parameter.component';
import { DateRangeSelectReportParameterComponent } from '../parameters/date-range-select-report-parameter.component';
import { DaysOfWeekReportParameterComponent } from '../parameters/days-of-week-report-parameter.component';
import { NumberOfCallersReportParameterComponent } from '../parameters/number-of-callers-report-parameter.component';
import { SelectedAccountReportParameterComponent } from '../parameters/selected-account-report-parameter.component';
import { TimeZoneReportParameterComponent } from '../parameters/time-zone-report-parameter.component';
import { ReportParameterConfig } from './report-parameter.config';

export type ReportParameterComponentAccessor = (reportParameter: ReportParameterConfig) => ComponentType<any>;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DefaultReportParameterComponentAccessor: ReportParameterComponentAccessor = (
   reportParameter: ReportParameterConfig
) => {
   switch (reportParameter.type) {
      case 'bool':
         return BooleanReportParameterComponent;
      case 'dateRange':
         return DateRangeReportParameterComponent;
      case 'dateRangeSelect':
         return DateRangeSelectReportParameterComponent;
      case 'timeZone':
         return TimeZoneReportParameterComponent;
      case 'selectedAccount':
         return SelectedAccountReportParameterComponent;
      case 'extensions':
         return ExtensionsReportParameterComponent;
      case 'extensionHuntGroups':
         return HuntGroupExtensionsReportParameterComponent;
      case 'extensionGroups':
         return ExtensionGroupsReportParameterComponent;
      case 'callQueueExtensions':
         return CallQueueExtensionsReportParameterComponent;
      case 'columnSort':
         return ColumnSortReportParameterComponent;
      case 'autoAttendantExtensions':
         return AutoAttendantExtensionsReportParameterComponent;
      case 'callDirections':
         return CallDirectionsReportParameterComponent;
      case 'callDispositions':
         return CallDispositionsReportParameterComponent;
      case 'daysOfTheWeek':
         return DaysOfWeekReportParameterComponent;
      case 'phoneNumbers':
         return PhoneNumbersReportParameterComponent;
      case 'numberOfCallers':
         return NumberOfCallersReportParameterComponent;
      case 'sortBy':
         return SortByReportParameterComponent;
      case 'extensionSortBy':
         return ExtensionSortByReportParameterComponent;
      case 'barGraphSource':
         return BarGraphSourceReportParameterComponent;
      case 'timeRange':
         return TimeRangeReportParameterComponent;
      default:
         throw Error('Unknown report parameter type');
   }
};
